/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import PropTypes from "prop-types";

// 600
// 800
// 1200
// 1600
const ResponsiveImage = ({
  src,
  srcMobile,
  alt,
  className,
  width,
  height,
  sizes,
  desktopWidth = "50vw",
  mobileWidth = "100vw",
  q = 75,
  title,
  style,
  lazyLoading = false,
  onClick = () => {},
  draggable,
}) => {
  if (!src) return null;
  // const blockIdWithoutSpaces = blockId.replace(/ /g, '');
  const getImgUrl = (url, w, webp) => {
    const queryWebp = webp ? `&webp=true` : "";
    return `/responsive-image?url=${url}&w=${w}&q=${q}${queryWebp}`;
  };
  const getSrcSet = (imgSrc, webp) => `
      ${getImgUrl(imgSrc, 10, webp)} 10w,
      ${getImgUrl(imgSrc, 50, webp)} 50w,
      ${getImgUrl(imgSrc, 100, webp)} 100w,
      ${getImgUrl(imgSrc, 150, webp)} 150w,
      ${getImgUrl(imgSrc, 200, webp)} 200w,
      ${getImgUrl(imgSrc, 250, webp)} 250w,
      ${getImgUrl(imgSrc, 320, webp)} 320w,
      ${getImgUrl(imgSrc, 390, webp)} 390w,
      ${getImgUrl(imgSrc, 450, webp)} 450w,
      ${getImgUrl(imgSrc, 600, webp)} 600w,
      ${getImgUrl(imgSrc, 700, webp)} 700w,
      ${getImgUrl(imgSrc, 800, webp)} 800w,
      ${getImgUrl(imgSrc, 900, webp)} 900w,
      ${getImgUrl(imgSrc, 1050, webp)} 1050w,
      ${getImgUrl(imgSrc, 1200, webp)} 1200w,
      ${getImgUrl(imgSrc, 1600, webp)} 1600w,
      ${getImgUrl(imgSrc, 1800, webp)} 1800w,
      ${getImgUrl(imgSrc, 2100, webp)} 2100w,
      ${getImgUrl(imgSrc, 2400, webp)} 2400w,
      ${getImgUrl(imgSrc, 2560, webp)} 2560w,
      ${getImgUrl(imgSrc, 3000, webp)} 3000w,
      ${getImgUrl(imgSrc, 3840, webp)} 3840w,
    `;
  const props = {};
  if (width) props.width = width;
  if (height) props.height = height;
  if (title) props.title = title;
  if (lazyLoading) props.loading = "lazy";
  if (onClick) props.onClick = onClick;
  if (draggable) props.draggable = draggable;

  if (src.endsWith(".svg"))
    return (
      <img
        className={className}
        src={`/responsive-image/?url=${src}&w=100`}
        alt={alt}
        {...props}
      />
    );

  return (
    <picture>
      {src && (!srcMobile || src === srcMobile) && (
        <>
          <source
            type="image/webp"
            sizes={
              sizes || `(min-width: 992px) ${desktopWidth}, ${mobileWidth}`
            }
            srcSet={getSrcSet(src, true)}
          />
          <source
            type="image/jpeg"
            sizes={
              sizes || `(min-width: 992px) ${desktopWidth}, ${mobileWidth}`
            }
            srcSet={getSrcSet(src)}
          />
          <source
            type="image/png"
            sizes={
              sizes || `(min-width: 992px) ${desktopWidth}, ${mobileWidth}`
            }
            srcSet={getSrcSet(src)}
          />
        </>
      )}

      {src && srcMobile && src !== srcMobile && (
        <>
          <source
            type="image/webp"
            media="(max-width: 991px)"
            sizes={`(max-width: 991px) ${mobileWidth}`}
            srcSet={getSrcSet(srcMobile, true)}
          />
          <source
            type="image/webp"
            media="(min-width: 992px)"
            sizes={`(min-width: 992px) ${desktopWidth}`}
            srcSet={getSrcSet(src, true)}
          />

          <source
            type="image/jpeg"
            media="(max-width: 991px)"
            sizes={`(max-width: 991px) ${mobileWidth}`}
            srcSet={getSrcSet(srcMobile)}
          />
          <source
            type="image/jpeg"
            media="(min-width: 992px)"
            sizes={`(min-width: 992px) ${desktopWidth}`}
            srcSet={getSrcSet(src)}
          />

          <source
            type="image/png"
            media="(max-width: 991px)"
            sizes={`(max-width: 991px) ${mobileWidth}`}
            srcSet={getSrcSet(srcMobile)}
          />
          <source
            type="image/png"
            media="(min-width: 992px)"
            sizes={`(min-width: 992px) ${desktopWidth}`}
            srcSet={getSrcSet(src)}
          />
        </>
      )}
      <img
        src={src || ""}
        alt={alt}
        className={className}
        {...props}
        style={style}
      />
    </picture>
  );
};

ResponsiveImage.propTypes = {
  alt: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string,
  desktopWidth: PropTypes.string,
  mobileWidth: PropTypes.string,
  sizes: PropTypes.string,
  q: PropTypes.number,
  width: PropTypes.number,
  height: PropTypes.number,
  style: PropTypes.shape({}),
  lazyLoading: PropTypes.bool,
  src: PropTypes.string,
  srcMobile: PropTypes.string,
  onClick: PropTypes.func,
  draggable: PropTypes.string,
};

export default ResponsiveImage;
